import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useActiveProject } from "@/context/ProjectContext";
import Designs from "@/pages/admin/Designs";
import LoadingScreen from "@/components/LoadingScreen";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function AdminDesigns() {
  const { activeProject } = useActiveProject();
  const [projects, setProjects] = useState(null);
  const [projectId, setProjectId] = useState(null);

  useEffect(() => {
    api.get("/projects", { params: { role: "administrador" } })
      .then((r) => setProjects(r.data || []))
      .catch(() => toast.error("No se pudieron cargar los proyectos."));
  }, []);

  useEffect(() => {
    if (projectId || !projects) return;
    const initial = (activeProject?.project_id && projects.some((p) => p.project_id === activeProject.project_id))
      ? activeProject.project_id
      : (projects[0]?.project_id || "none");
    setProjectId(initial);
  }, [projects, activeProject, projectId]);

  if (!projects) return <LoadingScreen text="Cargando diseños…" />;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-8 lg:py-12" data-testid="admin-designs-page">
      <div className="mb-6">
        <div className="caption mb-2">Gestión de diseños</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Diseños</h1>
        <p className="text-muted-foreground mt-2">Crea, edita y depura los dibujos 2D de tus proyectos.</p>
      </div>

      <div className="mb-6 flex flex-wrap items-center gap-3" data-testid="designs-project-picker">
        <span className="text-sm font-medium text-muted-foreground">Proyecto:</span>
        <Select value={projectId || ""} onValueChange={setProjectId}>
          <SelectTrigger className="w-full sm:w-80" data-testid="designs-project-select"><SelectValue placeholder="Elige un proyecto" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none" data-testid="designs-project-option-none">Sin proyecto asignado</SelectItem>
            {projects.map((p) => (
              <SelectItem key={p.project_id} value={p.project_id} data-testid={`designs-project-option-${p.project_id}`}>
                {p.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {projectId && <Designs key={projectId} projectId={projectId} />}
    </div>
  );
}
